import { Flex, Text, TextField } from '@scale/scaleui-radix';

interface ProjectIdInputProps {
  projectId: string | undefined;
  onChange: (projectId: string) => void;
}

export default function ProjectIdInput({ projectId, onChange }: ProjectIdInputProps) {
  return (
    <Flex direction="column" gap="2">
      <Text size="2" weight="bold">
        Step 1: Enter Hubstaff Project ID <span style={{ color: 'red' }}>*</span>
      </Text>
      <Text size="1" color="gray">
        You can find the Hubstaff Project ID in the Hubstaff URL or from the{' '}
        <a
          href="https://dashboard.scale.com/corp/dct/hubstaff-project-member-management"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'underline' }}
        >
          original management tool
        </a>
      </Text>
      <TextField.Root
        placeholder="Enter Hubstaff Project ID (e.g., 3686763)"
        value={projectId || ''}
        onChange={e => onChange(e.target.value)}
      />
    </Flex>
  );
}
